<div class="flex flex-col gap-y-8">
    <div class="flex flex-row pb-2 border-b border-border">
      <h1 routerLink="/dashboard/configuraciones/home" class="text-3xl text-dark mr-3 cursor-pointer">Configuración</h1>
      <h1 class="text-3xl text-dark">/ Examinadores</h1>
    </div>
    <app-generic-crud [genericCrud]="genericCRUD"></app-generic-crud>
  </div>
  